import React from "react";
import "assets/img/Logo.png"
import axios from 'axios';
// reactstrap components
import {
  FormGroup,
  Input,
  Button,
  Row,
  Col
} from "reactstrap";

class Login extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      email: "",
      password: "",
    };
  }

  login(event) {
    console.log(this.state.email);
    console.log(this.state.password);

    var config = {
       crossdomain: true
    };

    // Post Command To get token
    axios.post(`http://localhost:8080/login`,{
      "data":[{
    		"EMAIL": this.state.email,
    		"PASSWORD": this.state.password
    	}]
    },config)
    .then(res => {
      let data = res.data;
      if (!data.status) {
        alert("Invalid Login Credentials");
        window.location.reload();
      } else {
        localStorage.setItem('token', data.data);
        window.location.href = "#/user/dash";
      }
    });
  }

  handleChange(e) {
    this.state[e.target.id] = e.target.value;
  }

  render() {
    return (
      <>
      <div className="contentLogin">
      <img className="logo" src={ require("assets/img/Logo.png") } />
          <form>
            <Row>
            <Col md={{ size: 6, offset: 3 }} lg={{ size: 6, offset: 3 }}>
            <FormGroup>
              <Input
                type="email"
                id="email"
                placeholder="Enter email"
                onChange={ this.handleChange.bind(this) }
              />
          </FormGroup>
          </Col>
          </Row>
          <Row>
            <Col md={{ size: 6, offset: 3 }} lg={{ size: 6, offset: 3 }}>
          <FormGroup>
            <Input
              type="password"
              id="password"
              placeholder="Password"
              autoComplete="off"
              onChange={ this.handleChange.bind(this) }
            />
          </FormGroup>
          </Col>
          </Row>
          <div className="test">
          <Button onClick={this.login.bind(this)}>
            Login
          </Button>
          <Button href="#/signup">
            Sign Up
          </Button>
          </div>
        </form>
      </div>
      </>
    );
  }
}

export default Login;
